import { Loader } from '@googlemaps/js-api-loader';
import markerImage from '../images/map-marker.png';

/**
 * Same visual as Pharmacies.js createCustomMarkerIcon (marker + "Аптека BENU" label).
 *
 * @param {string} imageUrl
 * @return {Promise<string>}
 */
function createCustomMarkerIcon(imageUrl) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const dpr = window.devicePixelRatio * 4 || 1;

    const canvasWidth = 210;
    const canvasHeight = 200;
    const imageWidth = 70;
    const imageHeight = 70;
    canvas.width = canvasWidth * dpr;
    canvas.height = canvasHeight * dpr;

    canvas.style.width = `${canvasWidth}px`;
    canvas.style.height = `${canvasHeight}px`;

    const imageX = (canvasWidth - imageWidth) / 2;
    const imageY = 60;

    context.scale(dpr, dpr);

    const image = new Image();
    image.src = imageUrl;

    return new Promise((resolve) => {
        image.onload = () => {
            context.drawImage(image, imageX, imageY, imageWidth, imageHeight);

            context.shadowColor = 'rgba(0, 0, 0, 0.5)';
            context.shadowBlur = 10;
            context.shadowOffsetX = 2;
            context.shadowOffsetY = 2;

            context.font = 'bold 20px Arial';
            context.fillStyle = '#002664';
            context.textAlign = 'center';

            context.fillText('Аптека BENU', canvasWidth / 2, imageY + imageHeight + 25);

            resolve(canvas.toDataURL());
        };
    });
}

function initPharmacyShowMap() {
    const el = document.getElementById('js-pharmacy-show-map');
    if (!el) {
        return;
    }

    const apiKey = el.dataset.apiKey;
    const lat = parseFloat(el.dataset.lat);
    const lng = parseFloat(el.dataset.lng);

    if (!apiKey || Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
    }

    const loader = new Loader({
        apiKey,
        version: 'weekly',
        language: 'bg',
    });

    loader
        .load()
        .then(async () => {
            const map = new google.maps.Map(el, {
                center: { lat, lng },
                zoom: 16,
                mapTypeControl: true,
                streetViewControl: true,
                fullscreenControl: true,
            });

            const customIcon = await createCustomMarkerIcon(markerImage);

            new google.maps.Marker({
                position: { lat, lng },
                map,
                title: el.getAttribute('aria-label') || '',
                optimized: false,
                icon: {
                    url: customIcon,
                    scaledSize: new google.maps.Size(160, 160),
                },
            });
        })
        .catch(() => {
            /* optional: leave empty map container */
        });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPharmacyShowMap);
} else {
    initPharmacyShowMap();
}
